module.exports = __webpack_public_path__ + "static/img/gx.c6f4542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/gx.png
// module id = 8jcN
// module chunks = 2